import { Button, Flex, Popup, Text } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { memo } from 'react';
import bemFactory from 'react-bem-factory';

import { useTransferImpossiblePopupData } from './PopupTransferImpossible.hooks';
import { messages } from './PopupTransferImpossible.messages';
import { popupTransferImpossibleState } from './PopupTransferImpossible.states';

const qa = bemFactory.qa('message-impossibility-initiating-transfer-popup');

export const PopupTransferImpossible = memo(() => {
    const [isOpenTransferImpossiblePopup, toggleTransferImpossiblePopup] = useAtom(popupTransferImpossibleState);
    const { onContactSales } = useTransferImpossiblePopupData();

    return (
        <Popup
            size='small'
            open={isOpenTransferImpossiblePopup}
            onToggle={toggleTransferImpossiblePopup}
            data-qa={qa()}
        >
            <Popup.Header title={messages.title} />

            <Popup.Body data-qa={qa('content')}>
                <Flex container direction='column' spacing='24'>
                    <Flex size={24}>
                        <Text font='label' fontSize='medium'>
                            {messages.description}
                        </Text>
                    </Flex>

                    <Flex size={24}>
                        <Button
                            block
                            size='medium'
                            color='blue80'
                            onClick={onContactSales}
                            data-qa={qa('contact-sales-button')}
                        >
                            {messages.contactSalesButton}
                        </Button>
                    </Flex>
                </Flex>
            </Popup.Body>
        </Popup>
    );
});

PopupTransferImpossible.displayName = 'PopupTransferImpossible';
